import { Box, Grid, Typography } from "@mui/material";
import React, { memo } from "react";

const StatsCard = memo(({ label, value, bgColor }) => {
  return (
    <Box
      sx={{ p: 2, backgroundColor: bgColor, color: "white", height: "100%" }}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography align="center" variant="h3">
        {value}
      </Typography>
      <Typography align="center" variant="body2">
        {label}
      </Typography>
    </Box>
  );
});

const Stats = memo(({ data = {} }) => {
  const cardData = [
    {
      label: "Total Questions Answered",
      value: data?.totalMessage || 0,
      bgColor: "#1186c0",
    },
    {
      label: "Number of Guest Conversations",
      value: data?.totalThreadCount || 0,
      bgColor: "#9a85bb",
    },
    {
      label: "Staffing Hours Saved",
      value: data?.staffingHoursSaved || 0,
      bgColor: "#4cafd3",
    },
  ];

  return (
    <Grid container height="100%" gap={2}>
      {cardData.map((item, index) => (
        <Grid item size={12} key={index} width="100%">
          <StatsCard {...item} />
        </Grid>
      ))}
    </Grid>
  );
});

export default Stats;
